
/* styles */
require("!!../../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-01bb5a12&scoped=true!stylus-loader?{\"sourceMap\":true}!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./courseDetailsModal.vue")

var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./courseDetailsModal.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-01bb5a12!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./courseDetailsModal.vue"),
  /* scopeId */
  "data-v-01bb5a12",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/admin/adminPortal/courses/courseDetailsModal.vue
// module id = 2077
// module chunks = 61